import React from "react";
import ErcModal from "../../modules/shared/components/ErcModal";
import { stylerDecimalPart } from "../../utils/stylerDecimalPart";
import { convertMilisecondsToHoursFormat } from "../../utils/convertMilisecondsToHoursFormat";

export default function PriceOfferChildExplainer(props) {
  // PROPS COMING FROM PriceOfferChildTimeRestrictedDiscounted
  const { price, firstDiscount, remainingTime, additionalDiscount, context } =
    props;

  return (
    <div className="helvetica fs1125">
      {context === "firstUnit" ? (
        <>
          <p className="marb1">
            Süreli indirim kampanyası{" "}
            <span className="red-col">
              {convertMilisecondsToHoursFormat(remainingTime)}
            </span>{" "}
            sonra sona erecektir.
          </p>
          <p className="marb1">Bu süre boyunca bir ürünün 2 fiyatı vardır.</p>
          <p className="marb1">
            Bunlar <span className="slightlyyellowbck">"İlk Adet Fiyatı"</span>{" "}
            ve <span className="slightlyyellowbck">"Ek Adetler Fiyatı"</span>{" "}
            olarak isimlendirilir.
          </p>
          <p className="marb1">
            İndirim süresi boyunca sepete ilk attığınız ürün "İlk Adet Fiyatı"
            ile eklenir.
          </p>
          <p className="marb1">
            Sepete ekleyeceğiniz aynı ya da farklı ürünler ise "Ek Adet Fiyatı"
            ile sepete eklenir.
          </p>
          <p className="marb1">
            İndirim süresi sona erdiğinde üstü çizili{" "}
            <strike className="red-col">
              {parseInt(price)}.{stylerDecimalPart(price)}
            </strike>{" "}
            TL fiyat geçerli olur.
          </p>
          <p className="marb1 greenbcklight padq bold-font">
            Süre dolmadan şimdi bir sipariş oluşturun ve tasarruf edin.
          </p>
          <p className="marb1">
            Memnun kalır mıyım? Diye endişe etmeyin. beddo™'ya bir ürün iade
            etmek, satın almaktan çok daha kolay.
          </p>
          <ErcModal
            modalTitle={() => (
              <>
                <p>
                  Nasıl kolayca iade edilir
                  <i className="far fa-question-circle green fs125 marq"></i>
                </p>
              </>
            )}
            modalTitleDivWidth={"60%"}
            modalTitleFontSize={"1.25rem"}
            modalTitleLineHeight={"2rem"}
            modalTitleColor={"#0645ad"}
            modalTitleUnderline={""}
            contentTitle={`İade Başlatmak Çok Kolay`}
            contentTitleFontSize={"1.35rem"}
            content={[
              `* beddo.com müşteri hizmetleri sayfasına gidin.`,
              `* Sistemde kayıtlı cep telefonu numaranız ile güvenli giriş yapın.`,
              `* Giriş yaptıktan sonra siparişlerim sayfasına gidin ve "Kolay İade Başlat" butonunu tıklayın.`,
              `* Yönergeleri izleyerek saniyeler içinde bir ücretsiz kargo kodu oluşturun.`,
              `* İade paketi oluşturduğunuz kargo kodu ile kargo şubesine teslim edin. `,
              `* Akıllı beddo™ sistemi, iade paketi takip eder ve depomuza ulaşmasını takip eden 24 saat içinde kartınıza iade eder.`,
              `* Kapıda ödeme yaptı iseniz iade başlatırken girdiğiniz IBAN numarasına havale/EFT yapılır.`,
            ]}
            modalParagBorderBottom={"0.1rem solid #ff9935"}
            modalParagFontSize={"1.25rem"}
          />
        </>
      ) : context === "additionalUnits" ? (
        <>
          <p className="marb1">
            Süreli indirim kampanyası{" "}
            <span className="red-col">
              {convertMilisecondsToHoursFormat(remainingTime)}
            </span>{" "}
            sonra sona erecektir.
          </p>
          <p className="marb1">
            Sepetinizde her hangi bir ürün var ise ister aynı ürün olsun ister
            farklı, sepete ekleyeceğiniz her bir adet{" "}
            <span className="slightlyyellowbck">"Ek Adetler Fiyatı"</span> ile
            sepete eklenir.{" "}
          </p>
          <p className="marb1 greenbcklight padq bold-font">
            Süre dolmadan şimdi bir sipariş oluşturun ve tasarruf edin.
          </p>
          <p className="marb1">
            Adet ve çeşit sayısını artırarak daha çok indirim kazanın, ürün başı
            maliyetinizi düşürün.
          </p>
          <p className="marb1">
            Kaliteli bir ürüne uygun şartlarla sahip olmanın keyfini yaşayın.
          </p>
          <ErcModal
            modalTitle={() => (
              <>
                <p>
                  Nasıl kolayca iade edilir
                  <i className="far fa-question-circle green fs125 marq"></i>
                </p>
              </>
            )}
            modalTitleDivWidth={"60%"}
            modalTitleFontSize={"1.25rem"}
            modalTitleLineHeight={"2rem"}
            modalTitleColor={"#0645ad"}
            modalTitleUnderline={""}
            contentTitle={`İade Başlatmak Çok Kolay`}
            contentTitleFontSize={"1.35rem"}
            content={[
              `* beddo.com müşteri hizmetleri sayfasına gidin.`,
              `* Sistemde kayıtlı cep telefonu numaranız ile güvenli giriş yapın.`,
              `* Giriş yaptıktan sonra siparişlerim sayfasına gidin ve "Kolay İade Başlat" butonunu tıklayın.`,
              `* Yönergeleri izleyerek saniyeler içinde bir ücretsiz kargo kodu oluşturun.`,
              `* İade paketi oluşturduğunuz kargo kodu ile kargo şubesine teslim edin. `,
              `* Akıllı beddo™ sistemi, iade paketi takip eder ve depomuza ulaşmasını takip eden 24 saat içinde kartınıza iade eder.`,
              `* Kapıda ödeme yaptı iseniz iade başlatırken girdiğiniz IBAN numarasına havale/EFT yapılır.`,
            ]}
            modalParagBorderBottom={"0.1rem solid #ff9935"}
            modalParagFontSize={"1.25rem"}
          />
        </>
      ) : (
        <>
          <p>
            İlk adet için <span className="green">{firstDiscount}</span> TL
            indirim tanımlıdır.
          </p>
          <p className="marupside1">
            Sepete fazladan ekleyeceğiniz her bir adet için{" "}
            <span className="green">
              {parseInt(additionalDiscount)}.
              {stylerDecimalPart(additionalDiscount)}{" "}
            </span>
            TL indirim tanımlıdır.
          </p>
          <p>
            Böylece satın aldığınız adet sayısını artırdıkça her bir adet için
            ödediğiniz ortalama tutar düşer.
          </p>
        </>
      )}
    </div>
  );
}
